import React from "react";

const LoanAmount = ({
  utility,
  loanAmount,
  rebate,
  downPayment,
  id1,
  ppa1,
}) => {
  return (
    <span>
      {id1 === "115" ? "Purchase" : ppa1 === "1" ? "PPA" : "Loan"} Amount:{" "}
      {utility === "Salem Electric" ||
      utility === "Austin Energy" ||
      utility.includes("Xcel Energy")
        ? +loanAmount.toLocaleString(undefined, {
            style: "currency",
            currency: "USD",
          })
        : (+loanAmount + +rebate + +downPayment).toLocaleString(undefined, {
            style: "currency",
            currency: "USD",
          })}
    </span>
  );
};

export { LoanAmount };
